import { render, staticRenderFns } from "./NumberKeyboard.vue?vue&type=template&id=822efc30"
import script from "./NumberKeyboard.vue?vue&type=script&lang=js"
export * from "./NumberKeyboard.vue?vue&type=script&lang=js"
import style0 from "./NumberKeyboard.vue?vue&type=style&index=0&id=822efc30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports